<template>
    <div class="page-erreurs">
        <h1 class="titre-page">Erreurs TransCAM</h1>
        <div>getErreurs = 
            {{ getErreurs}}
        </div>
        <ListeErreurs :erreurs="erreurs" />

        <div class="actions">
            <button class="btn reset" @click="resetErreurs" v-if="erreurs.length > 0">
                🧹 Vider les erreurs
            </button>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions, mapMutations } from 'vuex';
import ListeErreurs from '@/components/TransCAM/ListeErreurTransCAM.vue'; // Adapte le chemin selon ton projet

export default {
  name: 'PageListeErreurTransCAM',
  components: {
    ListeErreurs
  },
  computed: {
    ...mapGetters('ErreurTransCAM', ['getErreurs']),
    erreurs() {
      return this.getErreurs;
    }
  },
        methods: {
            //...mapMutations('erreurTransCAM', ['setErreur']), // le nom du module si c’est namespaced

    ...mapActions('ErreurTransCAM', ['clearErreurs']),
    resetErreurs() {
      if (confirm('Es-tu sûr de vouloir tout supprimer ?')) {
        this.clearErreurs();
      }
    }
  }
}
</script>

<style scoped>
    .page-erreurs {
        max-width: 1000px;
        margin: auto;
        padding: 2rem 1rem;
    }

    .titre-page {
        text-align: center;
        margin-bottom: 2rem;
        font-size: 2rem;
        color: #333;
    }

    .actions {
        display: flex;
        justify-content: center;
        margin-top: 2rem;
    }

    .btn.reset {
        background-color: #f44336;
        color: white;
        border: none;
        padding: 0.8rem 1.4rem;
        font-size: 1rem;
        border-radius: 6px;
        cursor: pointer;
        transition: background-color 0.2s;
    }

        .btn.reset:hover {
            background-color: #d32f2f;
        }
</style>
